/**
 * Meta Integration Adapters
 *
 * Adapters implement IntegrationAdapter from ../adapter.ts
 * Each adapter is a plain object (no class hierarchy).
 *
 * Registration happens here — NOT in adapter files (Failure 5a prevention).
 * Adapter files export only the adapter object with no side-effect registrations.
 *
 * Implemented:
 * - Facebook Pages (Story 9.2)
 * - Facebook Ads (Story 9.3)
 * - Instagram Business (Story 9.4)
 * - Instagram Ads (Story 9.5)
 */
import { facebookPagesAdapter } from "./facebook-pages";
import { facebookAdsAdapter } from "./facebook-ads";
import { instagramBusinessAdapter } from "./instagram-business";
import { instagramAdsAdapter } from "./instagram-ads";
import { registerAdapter } from "../registry";

// Facebook Pages (Story 9.2)
registerAdapter("facebook-pages", facebookPagesAdapter);

// Facebook Ads (Story 9.3)
registerAdapter("facebook-ads", facebookAdsAdapter);

// Instagram Business (Story 9.4)
registerAdapter("instagram-business", instagramBusinessAdapter);

// Instagram Ads (Story 9.5)
registerAdapter("instagram-ads", instagramAdsAdapter);
